import { styles } from '../styles/theme';
import { radius } from '../styles/theme';

const StatusBadge = ({ status }) => {
  const style = styles.statusColors[status] || { bg: '#f1f5f9', color: '#475569' };
  return (
    <span style={{
      display: 'inline-block',
      padding: '3px 10px',
      borderRadius: radius.full,
      fontSize: '11px',
      fontWeight: '600',
      background: style.bg,
      color: style.color,
      letterSpacing: '0.01em',
    }}>
      {status}
    </span>
  );
};

export default StatusBadge;
